var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22222 16.7778L3.55556 12.1111L2 13.6667L8.22222 19.8889L21.5556 6.55556L20 5L8.22222 16.7778Z",
    fill: "#2F353A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico-done.dfa3bb29e4ce45113fa8719934acc55b.svg";